import getConfig from '../config';

export const watchlistActions = {
    GET_WATCHLISTS: {
        method: 'get',
        path: 'service/watchlists'
    },
    DELETE_WATCHLIST: {
        method: 'delete',
        path: 'service/watchlists'
    },
    CREATE_NEW_WATCHLIST: {
        method: 'post',
        path: 'service/watchlists'
    },
    RENAME_WATCHLIST: {
        method: 'put',
        path: 'service/watchlists'
    },
    UPDATE_WATCHLIST: {
        method: 'put',
        path: 'service/watchlists'
    }
};

export async function callApi(action, { id, body } = {}) {
    const { method } = action;
    const urlId = id ? `/${id}` : '';
    const watchlistUrl = `${getConfig(
        'apiDomain',
        'https://api.dev.awstrp.net'
    )}/frt-watchlist-service/service/watchlists${urlId}`;

    let headers = {
        method,
        credentials: 'include',
        headers: {
            apikey: getConfig('apiKey'),
            'Content-Type': 'application/json',
            'X-TRP-Requested-With': 'XMLHttpRequest'
        }
    };

    if (body) {
        headers = {
            ...headers,
            body: JSON.stringify(body)
        };
    }
    try {
        const result = await fetch(watchlistUrl, {
            ...headers
        });
        return result;
    } catch (err) {
        throw err;
    }
}
